import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    cancel: {
        id: 'iaso.label.cancel',
        defaultMessage: 'Cancel',
    },
    save: {
        id: 'iaso.label.save',
        defaultMessage: 'Save',
    },
    name: {
        id: 'iaso.label.name',
        defaultMessage: 'Name',
    },
    search: {
        id: 'iaso.search',
        defaultMessage: 'Search',
    },
    groups: {
        defaultMessage: 'Groups',
        id: 'iaso.label.groups',
    },
    projects: {
        id: 'iaso.label.projects',
        defaultMessage: 'Projects',
    },
    dataSource: {
        id: 'iaso.label.dataSources',
        defaultMessage: 'Data source',
    },
    create: {
        id: 'iaso.groups.create',
        defaultMessage: 'Create group',
    },
    sourceVersion: {
        id: 'iaso.groups.sourceVersion',
        defaultMessage: 'Source version',
    },
    blockOfCountries: {
        defaultMessage: 'Block of countries',
        id: 'iaso.groups.blockOfCountries',
    },
    sourceRef: {
        defaultMessage: 'Source ref',
        id: 'iaso.orgUnits.sourceRef',
    },
    updatedAt: {
        id: 'iaso.forms.updated_at',
        defaultMessage: 'Updated',
    },
    orgUnit: {
        id: 'iaso.label.orgUnit',
        defaultMessage: 'Org units',
    },
    actions: {
        id: 'iaso.label.actions',
        defaultMessage: 'Action(s)',
    },
    update: {
        id: 'iaso.groups.update',
        defaultMessage: 'Update group',
    },
    delete: {
        id: 'iaso.groups.dialog.delete',
        defaultMessage: 'Are you sure you want to delete this group?',
    },
    deleteWarning: {
        id: 'iaso.group.dialog.deleteText',
        defaultMessage: 'This operation cannot be undone.',
    },
    edit: {
        id: 'iaso.label.edit',
        defaultMessage: 'Edit',
    },
    deleteError: {
        id: 'iaso.snackBar.deleteGroupError',
        defaultMessage: 'An error occurred while deleting group',
    },
    deleteSuccess: {
        id: 'iaso.snackBar.delete_successful',
        defaultMessage: 'Deleted successfully',
    },
    groupSet: {
        id: 'iaso.label.groupSet',
        defaultMessage: 'Group Set',
    },
});

export default MESSAGES;
